import BhoomikaImg from "../img/Testimonials/Bhoomika Padhalni.jpg";
import ShivaaniImg from "../img/Testimonials/Shivaani Sharrma.jpeg";
import RuchitaImg from "../img/testimonials.jpg";
import AnithaImg from "../img/Testimonials/Anitha Selvan.jpg";
import HarshdeepImg from "../img/Testimonials/Harshdeep.jpg";
import BhumikaImg from "../img/Testimonials/Bhumika.jpg";
import PrabhjotImg from "../img/Testimonials/Prabhjot.jpg";
import PragatiImg from "../img/Testimonials/Pragati.jpg";
import ManujaImg from "../img/Testimonials/Manju Mishra.jpg";
import SurbhiImg from "../img/Testimonials/Surbhi Kumari.png";
import KanchanImg from "../img/Testimonials/Kanchan.jpg";
import AishwaryaImg from "../img/Testimonials/Aishwarya .jpg";
import NidhiSrivastavaImg from "../img/Testimonials/Nidhi Srivastava.jpg";
import AniTitusImg from "../img/Testimonials/Ani Titus.jpg";
import VKAnilKumarImg from "../img/Testimonials/VK Anil Kumar.jpeg";
import NidhiChoudharyImg from "../img/Testimonials/Nidhi Chaudhary.jpeg";
import event1 from '../img/Events/event1.JPG';
import event2 from '../img/Events/event2.JPG';
import event3 from '../img/Events/event3.jpeg';
import event4 from '../img/Events/event5.jpeg';
import event5 from '../img/30nov/nov1.jpeg';
import event6 from '../img/didac/didac1.jpeg';
import event7 from '../img//iismmumbai/iism1.jpeg';
import event8 from '../img/historicnothindiateam/team1.jpeg';
import traningImg from '../img/Services/Training 1.jpg';
import networkImg from '../img/Services/Conference 1.JPG';   
import rewardsImg from '../img/Services/Award 1.jpg';
import workshopsImg from '../img/Services/Webinar 0.jpg';
import img2 from "../../Assets/img/Marriott Navi Mumbai.jpg"

const importAll = (r) => {
  return r.keys().map((key) => r(key));
};

const iihmImages = importAll(require.context('../img/IIHM Delhi/', false, /\.(png|jpe?g|svg)$/));
const MumbaiImages = importAll(require.context('../img/Mumbai Meet/', false, /\.(png|jpe?g|svg)$/));
const NovImages = importAll(require.context('../img/30nov/', false, /\.(png|jpe?g|svg)$/));
const DidacImages = importAll(require.context('../img/didac/', false, /\.(png|jpe?g|svg)$/));
const HistoricImages = importAll(require.context('../img/historicnothindiateam/', false, /\.(png|jpe?g|svg)$/));
const IismImages = importAll(require.context('../img/iismmumbai/', false, /\.(png|jpe?g|svg)$/));

const FIMTImages = importAll(require.context('../img/FIMT Delhi/', false, /\.(png|jpe?g|svg|JPG|JPEG)$/i));
const AnnualConferenceImages = importAll(require.context('../img/Annual Conference/CLG Annual Conference Photos/', false, /\.(png|jpe?g|svg|JPG|JPEG)$/i));

export const TABS_CONTENT = [
  {
    title: "Who We Are",
    description:
    'The<strong> Association of Professional Career Counsellors of India</strong> (APCCI) is a <strong> Non-profit organization </strong> headquartered at New Delhi, India <strong>registered under Section 8 of the Companies Act 2013</strong>,  dedicated to supporting career counsellors across the country. What started as a humble WhatsApp group called "<strong>Career Launch Gurus</strong>" has grown into a recognised <strong> National Platform for Career counselling Professionals</strong> in just two years, thanks to the dedication and enthusiasm of its members.<br/><div style="text-align: center;"><strong style="color: #0047AB;"> Read more….</strong></div>',
  },
  {
    title: "We Aim",
    description:
      "To nurture a community of<strong> Professional Career Counsellors</strong> to deliver quality <strong>Career Guidance Services</strong> to the future workforce, thereby contributing to<strong> Nation building</strong>.",
  },
  {
    title: "Our Approach",
    description:
      "To empower and professionalise Career Counsellors through <strong>Training, Capacity building, Networking events, Research, Knowledge sharing, Policy making and Advocacy</strong>.",
  },
  {
    title: "Our Core Values",
    description: "",

    values: [
      {
        title: "Integrity",
        description:
          "Staying transparent by following ethical practices with honesty.",
      },
      {
        title: "Professionalism",
        description:
          "Excellence and high standards of competence in career counselling.",
      },
      {
        title: "Unbiased Guidance",
        description: "Fair, objective, and client-focused career guidance.",
      },
      {
        title: "Holistic Approach ",
        description:
          "Comprehensive guidance, addressing personal growth, aspirations, and well-being.",
      },
      {
        title: "Innovation ",
        description:
          "Continuously adapting and implementing new strategies in career counselling.",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Ruchita Kotadiya",
    role: "Independent Career Counsellor",
    organization: "Founder, FlyHigh career solutions",
    location: "Rajnandgaon, Chhattisgarh",
    image: RuchitaImg,
    quote: `APCCI is a vibrant community of passionate and skilled career counsellors dedicated to supporting and learning from one another. It encourages collaboration, mentorship, and ongoing development, creating a dependable network for professionals in the field.

The shared knowledge and networking opportunities have made a remarkable difference for me. APCCI offers a dependable space where counsellors connect, share insights, and grow professionally.`,
  },
  {
    name: "Shivaani Sharrma",
    role: "Independent Career Counsellor",
    organization: "Founder, Aptivize Career Counselling",
    location: "Faridabad",
    image: ShivaaniImg,
    quote: `It seems like yesterday when Kartik Badwa introduced me to Career Launch Gurus, now APCCI. I'm genuinely grateful to be part of it. As a career counsellor, I take pride in being part of this ethical community of independent professionals dedicated to making a positive impact.

Naren ji has always stood by us through thick and thin, proving that hard work can overcome any obstacle. We feel heard, valued, and secure within this association.

Our mission is rooted in selflessness, as we work together to support individuals on their career paths. By sharing knowledge and upholding the highest standards of integrity, we grow stronger together. I'm constantly inspired by my fellow counsellors and their dedication.

If you're a career counsellor seeking trustworthy peers, APCCI is your reliable partner at every step.`,
  },

  {
    name: "Anitha Selvan",
    role: "Independent Career Counsellor",
    organization: "Founder of Career Cognizance",
    location: "Bangalore",
    image: AnithaImg,
    quote: `Career counseling isn’t just about giving advice—it’s about truly understanding a person’s abilities, emotions, and dreams. While AI is evolving, it can never replace the warmth of human connection, the encouragement of a mentor, or the power of a heartfelt conversation.

    As career counsellors, we don’t just offer guidance; we become a bridge between aspirations and reality. But no single person can do this alone. It takes a community—a network of passionate individuals, experienced mentors, and institutions that believe in shaping the future.

    Together, we create not just career paths but confidence, hope, and success stories. Thank you for building a community that stands for unity, knowledge, and the emotional support every student and professional needs. The future isn’t built alone—it’s built together.`,
  },
  {
    name: "Harshdeep S. Kathuria",
    role: "Educator & Career Counsellor",
    organization: "HD EduMentors",
    location: "Muzaffarnagar, U.P",
    image: HarshdeepImg,
    quote: `Feels like yesterday that Robina Mittal introduced me to this generous group of counsellors. Naren Sir and all other team members have been a constant support since then. I am thankful to each and everyone who helped me get solutions to some questions that were challenging. Everyone volunteers as if we are a huge family taking care of each other.

    I would like to express my heartfelt gratitude to CLG, now APCCI, for their unwavering support in helping me grow my career counselling knowledge. Their round-the-clock assistance and expert guidance have been invaluable in navigating the challenges that I faced. The dedication to empowering counsellors like me has not only boosted my confidence but also significantly enhanced the quality of services I provide to my clients. Thank you for being a true partner in my professional journey and for always going above and beyond to support my growth.`,
  },
  {
    name: "Shiwani Beniwal",
    role: "Independent Career Counsellor",
    organization: "Career Immigration Pathway",
    location: "New Delhi",
    image: RuchitaImg,
    quote: `Career counselling requires a strong platform that understands students’ aspirations and helps guide them toward informed decisions. APCCI has been that reliable foundation for me. The education landscape is vast, and while one can only do so much alone, this community has helped extend my reach and knowledge.

    APCCI connects counsellors with like-minded professionals who share a passion for guiding students toward success.`,
  },
  {
    name: "Prabhjot",
    role: "Independent Career Counsellor",
    location: "New Delhi",
    image: PrabhjotImg,
    quote: `Becoming a member of APCCI has enriched my role as a counsellor. I now play a crucial part in guiding students through academic, emotional, and personal challenges, helping them develop life skills and confidence. The support I receive from APCCI is invaluable, with regular meetings and sessions offering fresh insights and updates.

    The collaborative environment among fellow counsellors provides ongoing learning and a strong sense of community. I truly appreciate the valuable information shared and the camaraderie within this network. Special thanks to Naren Sir and PK Joseph for their consistent mentorship and support.`,
  },
  {
    name: "Pragati Imam",
    role: "Independent Career Counsellor",
    organization: "Founder, CollegeEdge",
    location: "Kolkata",
    image: PragatiImg,
    quote: `As a career counsellor, my purpose is clear: to guide students in the best way possible. But the pursuit of knowledge is endless—where should I learn from? Who should I connect with for deeper insights? How do I grow from others' experiences or find a sounding board for my thoughts?

    In Career Launch Gurus, now APCCI, I found my friend, my mentor, and my guide. No single mind can grasp the vast landscape of career counseling, but this community connects me to experts across fields—whether it’s design, medicine, engineering, or beyond. Here, I find advice, insights, and a network that fuels my growth and, in turn, helps me impact student lives more meaningfully.

    Beyond learning, this community also gives me the joy of giving back—sharing my strengths, experiences, and knowledge with peers who are just as passionate about shaping futures. It’s a space where collaboration thrives, where we uplift each other to achieve the best outcomes for students.

    I’m grateful to Naren Sir for his vision and to mentors like Kartik Sir, who have guided and supported all of us in this journey. If you’re a career counsellor seeking knowledge, support, and a like-minded community, APCCI is where you belong.`,
  },
  {
    name: "Manuja Mishra",
    role: "Independent Career Counsellor",
    organization: "Founder, Thee Purplee Housee",
    location: "Guna, M.P.",
    image: ManujaImg,
    quote: `I feel truly lucky for being a part of the 'Career Launch Gurus' community. It has been an enriching experience since day one. The everyday guidance and timely support from the career counsellors keep the community active and updated. The shared experiences and constant encouragement from the experienced counsellors in the group have helped me grow professionally and personally.

    This community fosters collaboration, learning, and a shared commitment to empowering students with the right career guidance. I am truly honored to be a part of this family and look forward to contributing to its continued success. I wish for us to grow into the largest community of career counsellors together and make a lasting, positive impact in the lives of everyone!`,
  },
  {
    name: "Surbhi Kumar",
    role: "Founder & Chief Mentor",
    organization: "The Dream Catchers",
    location: "Mumbai",
    image: SurbhiImg,
    quote: `As Education Consultants, staying informed about industry trends, college admission policies, and reviews is essential for offering top-quality guidance. Being part of a community like Career Launch Gurus, where consultants share authentic information and support each other, has benefited my practice.

    I’m grateful for the positive impact this community has made in the education and career advisory field.`,
  },
  {
    name: "Kanchan AG",
    role: "Independent Career Counsellor",
    organization: "KNG LifeGyaan",
    location: "Navi Mumbai",
    image: KanchanImg,
    quote: `Career Launch Gurus, now APCCI, has been a fantastic space to connect, collaborate, and grow with fellow counselors, educators, and university outreach teams.

    From insightful campus visits to meaningful partnerships, it has made navigating the education space both enriching and exciting.

    Grateful for the opportunities, insights, and friendships this community brings. Here’s to more learning, collaborations, and, hopefully, fewer career dilemmas!`,
  },
  {
    name: "Aishwarya Verma",
    role: "Independent Career Counsellor",
    organization: "Career Fame",
    location: "Ghaziabad",
    image: AishwaryaImg,
    quote: `I am sure introducing ourselves as Career counsellors comes with a huge responsibility, and we are definitely looked up to as individuals with enormous knowledge and experience. This was the feeling when I entered, until I bumped into this bunch of enthusiastic, energetic, passionate counsellors willing to always help. 

    This platform has so much to offer to everyone who is associated with it, and that willingness to keep sharing is the biggest strategy for growth. I think some very disciplined and wonderful visionaries are the pillars of strength of this community. 

    Thankful to have found it and shall always be willing to contribute in this space.`,
  },
  {
    name: "Nidhi Srivastava",
    role: "Independent Career Counsellor",
    organization: "Synergist Career Solution",
    location: "Ghaziabad",
    image: NidhiSrivastavaImg,
    quote: `My journey with this community started a year and a half ago, and it has been a fantastic learning experience. The knowledge, mentorship, and opportunities I have received have shaped my career growth in unexpected ways.

    A special thanks to Mr. Naren Verma, whose vision has been instrumental in creating this platform. I’m also deeply grateful to my mentors—Mr. P.K. Joseph, Mr. Kartik Baldawa, Mr. Aman, Dr. Shruti, and Kavita Ma’am—for their invaluable support.

    As Career Launch Gurus transitions to APCCI, I look forward to contributing to its continued growth and betterment for students and counsellors.`,
  },
  {
    name: "Ani Titus",
    role: "Independent Career Counsellor & Co-Founder",
    organization: "Ask A Student",
    location: "Navi Mumbai",
    website: "www.AskAStudent.net",
    image: AniTitusImg,
    quote: `After an 8-year career break, I restarted my professional journey by joining a startup called Ask A Student in the education sector. While working there, I interacted with many students, guiding and counseling them. That’s when I discovered my true passion for mentoring students.

    To strengthen my expertise, I enrolled in a certification program from Univariety, and upon completion, I was invited to join Career Launch Gurus, now APCCI, a community of counsellors founded by Mr. Narenji. This network became a priceless asset to me, like a treasure trove of wisdom and support. Whenever I had doubts, I found not just one but multiple perspectives, each offering valuable insights.

    Since then, my journey has been nothing short of fulfilling. The seminars, offline meets, and interactive sessions are simply the icing on the cake, enriching the experience even further. I firmly believe that growth comes from sharing knowledge.

    If you are a counsellor reading this and haven't yet joined this incredible community, I wholeheartedly encourage you to do so. Connect, learn, share, and uplift others, because in giving, we receive the most. Let’s grow together!`,
  },
  {
    name: "V K Anil Kumar",
    role: "Independent Career Counsellor, Motivational Speaker & Author",
    location: "Kerala",
    website: "http://www.anilscareerguidance.com",
    image: VKAnilKumarImg,
    quote: `Bringing career counsellors together under one umbrella is a unique and enriching experience. It serves as a knowledge hub for counsellors at both national and international levels, providing access to a wealth of insights from scholars, experts, and industry leaders.

    This platform has not only enhanced my professional profile but also contributed to lead generation. The seminars, webinars, gatherings, and collaborative knowledge-sharing sessions offer lessons that go beyond what a university can provide.`,
  },
  {
    name: "Bhoomika Padhalni",
    role: "Independent Career Counsellor",
    location: "Delhi",
    image: BhoomikaImg,
    quote: `Being part of Career Launch Gurus, now APCCI, has transformed my journey as a career counsellor. In an industry that is constantly evolving, staying current, connected, and confident is essential—and this community provides exactly that.

What stands out is the genuine dedication to supporting independent career counsellors across India. Whether you're just starting or have years of experience, the regular webinars, industry visits, and events ensure continuous learning. These sessions offer both advanced knowledge and practical insights to keep up with changes in career counselling.

Beyond knowledge, the biggest strength of this community is its people—mentors, peers, and experts who are always ready to share and support. The connections I've built here have expanded my network and given me the confidence to take bold steps in my career.

If you're a career counsellor seeking growth, knowledge, and a strong network, APCCI is the place to be. It's not just a learning platform; it's a reliable support system. Highly recommended for anyone passionate about helping students make informed career decisions!`,
  },
  {
    name: "Nidhi Choudhary",
    role: "Independent Career Counsellor",
    location: "Bangalore",
    image: NidhiChoudharyImg,
    quote: `I'm Nidhi Choudhary, a seasoned professional with over 15 years of experience in the Human Resources and Education sectors. As a career counsellor, I've had the privilege of guiding many individuals on their career journeys.

    I found APCCI while searching for a platform to connect with fellow counsellors and stay updated on industry trends. The supportive environment and wealth of shared knowledge immediately drew me in.

    Since joining, I've refined my counselling skills, expanded my network, and accessed valuable insights. The opportunity to collaborate and learn has been particularly rewarding.

    I recommend APCCI to career counsellors seeking growth, resources, and a supportive community. It’s an invaluable resource for staying current and connected.`,
  },
  {
    name: "Bhumika Parekh",
    role: "Career and Global Education Consultant",
    location: "Mumbai",
    website: "edulifegoals.com",
    image: BhumikaImg,
    quote: "Being part of APCCI has greatly enhanced my growth as a career education consultant. The platform keeps me updated on admission trends and global education insights while fostering meaningful peer exchange. Through webinars and knowledge-sharing, it has strengthened my student guidance approach with clarity, confidence, and integrity. I'm proud to be part of a community that values ethical counselling and continuous learning."
  }
];

export const FAQ_ITEMS = [
  {
    question: "What is APCCI?",
    answer:
      " APCCI stands for the Association of Professional Career Counsellors of India, a non-profit organization dedicated to supporting certified career counsellors through training, networking, advocacy, and resource sharing.",
  },
  {
    question: "Who can become a member?",
    answer:
      " Membership is open to certified career counsellors who want to connect, learn, and grow with a vibrant community of professionals.",
  },
  {
    question: " How do I join APCCI?",
    answer:
      ' Simply click the "Join Now" button on our website, complete the registration form, and pay the annual membership fee.',
  },
 // {
  //  question: "What benefits do I get as a member?",
   // answer:
   //   "As a member, you gain access to specialized training, expert-led webinars, research resources, networking events, mentorship, and opportunities to earn recognition.",
 // },
 // {
  //  question: " Is there a membership fee?",
  //  answer:
  //    "Yes, there is an annual membership fee. Detailed information about the fee and its benefits is available on the membership page.",
  //},
  {
    question: "Can I access APCCI resources and events without being a member?",
    answer:
      " Some resources and events are exclusive to members, but we also host public sessions. Check our events page for updates.",
  },
  {
    question: "How does APCCI support career counsellors?",
    answer:
      "We offer ongoing support through training programs, webinars, mentorship, research resources, and networking events to help members stay updated and improve their practice.",
  },
  {
    question: "Does APCCI offer certifications or job placements?",
    answer:
      "While we donot offer certifications right now or guarantee any job placements, we provide learning opportunities and connections to help members grow professionally, collaborate and expand their practice.",
  },
  {
    question: "Can I contribute as a volunteer or a mentor?",
    answer:
      " Yes, we encourage experienced members to volunteer as mentors, participate in events, and contribute by being a part of APCCI Functional committees as and when invited.",
  },
];

export const SERVICES = [
  {
    title: "Training & Capacity Building",
    description:
      "Gain new skills and earn certifications with expert-led training programs customised to your professional growth.",
    image: traningImg,
  },
  {
    title: "Conferences & Networking Events",
    description:
      "Join national and regional events to meet peers, share ideas, and discover collaboration opportunities.",
      image: networkImg,
  },
  {
    title: "Awards & Recognitions",
    description:
      "Be recognized for your efforts and accomplishments with industry recognised prestigious awards.",
      image: rewardsImg,
  },
  {
    title: "Webinars & Workshops",
    description:
      "Stay updated with interactive sessions on ethical practices, industry updates, and skills development.",
      image: workshopsImg,
  },
];

export const RECENT_EVENTS = [
  // {
  //   id: "event1",
  //   title: "All India Convention Of Career Counsellors & Awards 2025",
  //   description: 'AICCC 2025 isn’t just another event. It’s India’s premier gathering of Career Counsellors, Educators, and Industry Leaders where ideas ignite, connections turn into collaborations, and insights turn into impact. Whether you’re an established Career Guidance Professional, an Educator advocating change, or an aspiring Career counsellor, this is where you belong.',
  //   details: [
  //     "Keynote Speeches: Hear from industry leaders and visionaries shaping the future of career counselling.",
  //     "Panel Discussions: Engage in thought-provoking conversations on emerging trends and challenges.",
  //   ],
  //   date: "23rd Aug 2025",
  //   location: "Pride Plaza Hotel, Aerocity, Delhi",
  //   image: img2,
  //   attendees: "200+ ",
  //   organizer: "Association of Professional Career Counsellors of India (APCCI)",
  //   galleryImages: AICCC2025Images,
  //   aboutMore: {
  //     label: "Read More",
  //     path: "https://www.linkedin.com/posts/career-launch-gurus_aiccc2025-careercounsellors-convention-activity-7324326145766221312-3p0G?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
  //   }
  // },
  {
    id: "event2",
    title: "Career CONNECT Summit at IIHM, Delhi",
    description: `
     Career Launch Gurus recently hosted an exciting meet-up for independent career counsellors from North India at the IIHM Campus, Delhi. This event was a transformative step toward reshaping the career counselling ecosystem in India .This meet-up wasn’t just an event—it was a movement to inspire, connect, and transform the future of career guidance.


    `,
    details: [
      "Industry Insights: A deep dive into careers in hospitality and tourism.",
      "IIHM Campus Visit: Hands-on experience in labs and kitchens for real-world insights.",
      "Collaborative Activities: Exploring the “Me2We” approach to navigate fast-changing dynamics.",
      "Expert Talks: Guidance on entrance exams and career pathways in hospitality and tourism.",
      "Way Forward: Building a collaborative ecosystem to empower career counsellors."
    ],
    date: "21st Dec 2024",
    location: "IIHM, Delhi",
    image: event3,
    attendees: "30+ ",
    organizer: "Career Launch Gurus at IIHM Campus, Delhi ",
    galleryImages: iihmImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_careercounselling-collaboration-northindiacounsellors-activity-7277000252153368577-V3-J?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {    
    id: "event3",
    title: "CONNECT Meet (West) at Ecole Intuti Lab, Mumbai",
    description: `
    The Mumbai team of Career Launch Gurus, now APCCI organized an incredible visit to École Intuit Lab, a top French design school in India. This wasn’t just a networking event—it was a powerful opportunity for counsellors to connect, exchange insights, and grow together.If you’re a certified career counsellor passionate about making a difference, Join this wonderful initiative.  
   `,
   details: [
     "The event was filled with positivity, enthusiasm, and collaboration, making it a truly impactful experience for everyone involved.",
     "This visit was a significant step forward in strengthening our community and creating learning opportunities for career counsellors.",
     "APCCI is working on bigger initiatives to bring even more exciting opportunities for counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡",
   ],
    date: "18th Oct 2024",
    image: event4,
    organizer: "APCCI",
    attendees: "20+ Participants ",
    galleryImages: MumbaiImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_clgmumbai-careerlaunchgurus-communitygrowth-activity-7253730828143280128-7cUj?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }

  },
  {
    id: "event4",
    title: "CONNECT Meet (North) at FIMT, Delhi",
    date: "20th Sep 2024",
    image: event1,
    description: " Career Launch Gurus North Team hosted an inspiring and productive Quarterly Meet at the Fairfield Institute of Management and Technology (FIMT) on 20th September 2024.If you’re a certified career counsellor passionate about making a difference, join this wonderful initiative",
    details: [
      "Counsellors from across India came together for a day filled with learning, sharing, and collaboration, taking a step forward in strengthening our community and shaping the future of career counselling.",
      "This visit was an opportunity to explore the credible and value-driven programs offered by FIMT, all designed to holistically uplift students while instilling essential life values.",
      "The vision of FIMT’s leadership—starting from Chairman Mr. V.K. Nangalia Bhardwaj, Director Dr. Saroj Vyas, and extending to the dedicated faculties, admin staff, and happy students—left a lasting impression. Their commitment to excellence and student growth is truly inspiring.",
      "This visit was a significant step forward in strengthening our community and creating learning opportunities for career counsellors.",
      "APCCI is working on bigger initiatives to bring even more exciting opportunities for counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡"
    ],
    location: "FIMT, Delhi",
    organizer: "APCCI",
    attendees: "25+ ",
    galleryImages: FIMTImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_careerlaunchgurus-counsellorcommunity-learningtogether-activity-7244038869229146113-85oK?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {
    id: "event5",
    title: "Career Launch Gurus (CLG) 1st Annual Conference, New Delhi",
    date: "13th July 2024",
    image: event2,
    description: "What an incredible journey it has been! In just one year, Career Launch Gurus (CLG) has grown beyond our wildest dreams, and on 13th July 2024, we celebrated this milestone with our inaugural Annual Conference in Delhi.Career counsellors from across India came together under one roof to celebrate, learn, and share, bringing our motto, “Grow Together,” to life. ",
    details: "The energy, passion, and collaboration were truly unforgettable.The day began with an inspiring session by PK Jose, CEO of Career Spotters Global Pvt Ltd, who explored how NEP 2020 & NCF 2023 are reshaping the career counselling industry.Ms. Kavita Soni, a renowned content creator and researcher, demystified the world of entrance exams in her session, “Cracking the Code of Entrance Exams.” She highlighted how CUET is bringing structure and clarity to college admissions.Our Chief Guest, Mr. DK Singh, Program Director at NIESBUD (Govt. of India), painted a vivid picture of “Exponential Opportunities in Entrepreneurship.” His insights into India’s entrepreneurial ecosystem left everyone inspired and ready to explore new avenues.Post-lunch, Dr. Shruti Jain energized the room with her talk on career development theories, ethical guidelines, and specialized counselling areas. Her passion sparked lively discussions and fresh ideas.Ms. Chetna Basra from Delhi Institute of Computer Sciences (DICS Technologies Ltd.) shared valuable resources for student profile building and skill development, equipping counsellors with practical tools to guide their students.The event concluded with Mr. Naren Verma, National Convener of CLG and Founder-CEO of Life Commando. Through humour and storytelling, he emphasized the importance of addressing root causes in career counselling and shared insights on building self-sustainable counselling businesses As the day ended, participants left with newfound knowledge, inspiration, and a promise to apply what they learned, track their progress, and return to share their journeys.This conference was just the beginning. CLG, now APCCI is working on bigger initiatives to create more opportunities for career counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡If you’re passionate about transforming careers and being part of a collaborative, growing community, join this wonderful initiative.",
    location: "Karol Bagh, New Delhi",
    organizer: "APCCI",
    attendees: "30+",
    galleryImages: AnnualConferenceImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_careerlaunchgurus-activity-7218146783883923456-Wl5f?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {
    id: "event6",
    title: "CLG North India Meet at IIHM, Delhi",
    date: "30th Nov 2024",
    image: event5,
    description: `
    On 30th November, senior counsellors from Career Launch Gurus, now APCCI came together in Delhi for a pivotal coordination conference. The focus? Creating a non-competitive ecosystem for collaboration among career counsellors.This meeting marked the beginning of something BIG—a movement to redefine collaboration and create immense value for career counsellors across India.
   `,
   details: [
     "On 30th November, senior counsellors from Career Launch Gurus, now APCCI came together in Delhi for a pivotal coordination conference. The focus? Creating a non-competitive ecosystem for collaboration among career counsellors.",
     "Turning challenges into actionable solutions.",
     "Defining the community’s role in empowering career counsellors.",
     "Outlining roles and responsibilities for joint projects.",
     "Exploring fair and effective remuneration models."
   ],
    location: "IIHM, Delhi",
    organizer: "APCCI",
    attendees: "12+  ",
    galleryImages:  NovImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_careerlaunchgurus-collaboration-careercounselling-activity-7269962123445747712-RL9T?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {
    id: "event7",
    title: " Counsellors Visit to DIDAC 2024 at New Delhi",
    date: "18-20th September 2024",
    image: event6,
    description: `
    As career counsellors from across India, we explored the latest trends and innovations shaping the future of education. The event was packed with knowledge, fresh insights, and opportunities to connect with fellow counsellors, educators, industry leaders, and tech pioneers who are redefining learning.“The world is the true classroom. The most rewarding and important type of learning is through experience.” – Jack Hanna
Want to be part of our amazing community and stay updated on the latest trends in the industry? Join this wonderful initiative.


   `,
   details: [
     "This came to life when the Career Launch Gurus, now APCCI team had an incredible experience at #DIDAC2024, held at Delhi’s Yashobhoomi Convention Centre from September 18-20.",
     "As career counsellors from across India, we explored the latest trends and innovations shaping the future of education. The event was packed with knowledge, fresh insights, and opportunities to connect with fellow counsellors, educators, industry leaders, and tech pioneers who are redefining learning.",
     "This experience was a significant step forward in staying ahead of industry trends and creating meaningful connections.",
     "APCCI is working on bigger initiatives to bring even more exciting opportunities for counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡",
   ],
    location: "IIHM, Delhi",
    organizer: "APCCI",
    attendees: "40+  ",
    galleryImages: DidacImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_didac2024-careerlaunchgurus-learningtogether-activity-7243620559404568576-YCyS?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {
    id: "event8",
    title: " Career Counsellors Meet at IISM Mumbai ",
    //date: "16th march 2025",
    image: event7,
    description: `
    Career Launch Gurus (CLG) now APCCI, in collaboration with International Institute of Sports & Management (IISM), Mumbai, hosted an insightful meet on Careers in Sports Management & Science. Big Learning: Career counselling is evolving! Equip students with insights into emerging industries like sports.Stay ahead in career counselling. Join the vibrant APCCI Now!
   `,
   details: [
     "Sports careers are expanding—analytics, psychology, event management, and more!",
     " Networking with industry experts opened doors to high-growth opportunities.",
     "Explored sports science, performance analysis, and entrepreneurship.",
     "APCCI is working on bigger initiatives to bring even more exciting opportunities for counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡",
   ],
    location: "IISM, Mumbai",
    organizer: "APCCI",
    attendees: "20+  ",
    galleryImages: IismImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_careercounselling-sportscareers-careerlaunchgurus-activity-7306612294673747968-sqFN?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
  {
    id: "event9",
    title: " A Historic Moment: First Physical Meet of the North India Team!  ",
    date: "30th march 2024",
    image: event8,
    description: `
    History was made on 30th March 2024 as CareerSpotters Global Pvt Ltd hosted the first physical meeting of the North India Team of Career Launch Gurus, now APCCI at their Noida office.
The event brought together career development professionals who share the same vision, mission, and professional aspirations, marking a significant milestone in our journey to transform career counselling in India.If you’re passionate about transforming careers and being part of a collaborative, growing community, join this wonderful initiative.

   `,
   details: [
     "Attendees connected over their shared passion for empowering students and explored ways to collaborate, learn, and grow together.",
     "A big shoutout to our Delhi NCR Team for flawlessly organizing this first physical meet. Your hard work and dedication made this event a huge success!",
     "This meet was just the beginning. Career Launch Gurus is working on bigger initiatives to create more opportunities for career counsellors across India. Stay tuned—there’s much more to come as we build a brighter future together! 🌍💡",
   ],
    location: "North India",
    organizer: "CareerSpotters Global Pvt Ltd ",
    attendees: "12+  ",
    galleryImages: HistoricImages,
    aboutMore: {
      label: "Read More",
      path: "https://www.linkedin.com/posts/career-launch-gurus_it-was-a-pleasure-meeting-with-all-of-you-activity-7179881676800434178-7FNo?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEphGAwBAalj59bo46A35QKLqtR8qmn3iA0"
    }
  },
];
export const NEWS = [
  {
    title: "APCCI Launches New Certification Program",
    date: "January 20, 2024",
    summary:
      "Our latest certification program is designed to enhance professional skills and knowledge.",
    link: "/news/certification-launch",
  },
  {
    title: "Success Story: Career Counselor of the Year",
    date: "February 10, 2024",
    summary:
      "Meet Dr. Priya, awarded Career Counselor of the Year for her impactful guidance.",
    link: "/news/career-counselor-award",
  },
  {
    title: "Research: Career Trends in 2024",
    date: "March 5, 2024",
    summary:
      "Our latest research report provides insights into emerging career trends.",
    link: "/news/career-trends-2024",
  },
];

export const RESOURCES = [
  {
    title: "Career Guidance Handbook",
    link: "https://apcci-resources.org/handbook",
  },
  {
    title: "Certification Programs",
    link: "https://apcci-resources.org/certifications",
  },
  {
    title: "Job Search Strategies",
    link: "https://apcci-resources.org/job-search",
  },
  {
    title: "Resume Writing Tips",
    link: "https://apcci-resources.org/resume-writing",
  },
  {
    title: "Interview Preparation",
    link: "https://apcci-resources.org/interview-prep",
  },
  {
    title: "Professional Development Webinars",
    link: "https://apcci-resources.org/webinars",
  },
  {
    title: "Networking Opportunities",
    link: "https://apcci-resources.org/networking",
  },
  {
    title: "Job Placement Support",
    link: "https://apcci-resources.org/job-placement",
  },
  {
    title: "Workplace Skills Training",
    link: "https://apcci-resources.org/workplace-skills",
  },
];
